export const copyToClipboard = async (copyText: string) => {
  try {
    await navigator.clipboard.writeText(copyText);
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};
